module.exports = __webpack_public_path__ + "img/59.c41320aa.gif";